module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"engineRebuildingOrderStatuses":"Estados de Orden de la Rectificadora"},"en":{"engineRebuildingOrderStatuses":"Engine Rebuilding Order Statuses"}}')
  delete Component.options._Ctor
}
